import { CallMemo } from '@work4all/models/lib/Classes/CallMemo.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/callMemo-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function CallMemoTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<CallMemo, never>({
    ...props,
    schema: schema as never,
    defaultSort,
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
